import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/site";
import { useSiteSettings } from "../context/SiteSettingsContext";

const Hero = () => {
  const s = useSiteSettings();
  const [titleA, titleB] = (s.hero_title || "Premium Pitch Wear.").split(/\s+(?=\S+$)/);
  return (
    <section className="relative bg-chalk overflow-hidden" data-testid="home-hero">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-8 pt-10 md:pt-14">
        <div className="lg:col-span-5 flex flex-col justify-between pb-10 lg:pb-20">
          <div>
            <div className="overline mb-6" data-testid="hero-season-tag">
              {s.current_season || "FW26"} · Series 01
            </div>
            <h1 className="uppercase tracking-tight font-extrabold leading-[0.92] text-5xl sm:text-6xl lg:text-[5.6rem]">
              {titleA}
              <br />
              {titleB}
            </h1>
            <p className="mt-8 max-w-md text-base md:text-lg text-mute leading-relaxed">
              {s.hero_subtitle}
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Link to="/shop" className="btn-primary" data-testid="hero-shop-button">
              {s.hero_cta_primary || "Shop Grip Socks"} <ArrowRight size={14} className="ml-2" />
            </Link>
            <Link
              to="/shop#colourways"
              className="btn-secondary"
              data-testid="hero-colourways-button"
            >
              {s.hero_cta_secondary || "View Colourways"}
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-6 mt-12 pt-8 border-t border-line">
            <div>
              <p className="mono text-xs text-mute">01 / GRIP</p>
              <p className="text-sm">Boot-lock zones</p>
            </div>
            <div className="h-8 w-px bg-line" />
            <div>
              <p className="mono text-xs text-mute">02 / FIT</p>
              <p className="text-sm">Thin-touch L/R</p>
            </div>
            <div className="h-8 w-px bg-line" />
            <div>
              <p className="mono text-xs text-mute">03 / FINISH</p>
              <p className="text-sm">12 colourways</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 relative">
          <div className="aspect-square w-full overflow-hidden border border-line bg-white">
            <img
              src={IMAGES.hero}
              alt="Pritch grip socks — Series 01 lineup on pitch"
              className="w-full h-full object-contain"
              data-testid="hero-image"
            />
          </div>
          <div className="absolute top-4 right-4 bg-ink text-white px-3 py-2 hidden md:block">
            <p className="mono text-[10px] tracking-widest uppercase">Grip. Fit. Finish.</p>
          </div>
        </div>
      </div>

      {/* Ticker */}
      <div className="border-y border-line bg-white mt-10 lg:mt-0">
        <div className="overflow-hidden whitespace-nowrap py-4">
          <div className="inline-flex animate-marquee">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={`ticker-pass-${i}`} className="inline-flex items-center gap-12 pr-12">
                {[
                  "Boot-Lock Grip",
                  "Close Boot Feel",
                  "Matchday Comfort",
                  "Colour-Matched",
                  "Left / Right Anatomical",
                  "Built for Rotation",
                  "Grip. Fit. Finish.",
                ].map((t, idx) => (
                  <span
                    key={`ticker-${i}-${idx}`}
                    className="uppercase tracking-tight text-lg text-ink font-bold"
                  >
                    {t} <span className="text-mute mx-3 font-normal">/</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
